import store from '@/store'
import WebSocketProvider from '@/websocket'
import { WebSocketMessageMode } from '@/websocket/constants'
import { WebSocketStatusMessageTypes } from '@/websocket/receivers/status'
import {
  ReceiveMessageBodyStatusLogin,
  ReceiveMessageBodyStatusLogout
} from '@/websocket/receivers/status/receiveMessages'

export const createOnlineStatusConnection = () => {
  store.dispatch('onlineStatus/fetch')

  const ws = WebSocketProvider.createConnection()

  ws.subscribeMessage(
    WebSocketMessageMode.STATUS,
    WebSocketStatusMessageTypes.LOGIN,
    ({ user }: ReceiveMessageBodyStatusLogin) => {
      store.commit('onlineStatus/setOnlineStatus', {
        [user]: {
          user,
          isOnline: true
        }
      })
    }
  )

  ws.subscribeMessage(
    WebSocketMessageMode.STATUS,
    WebSocketStatusMessageTypes.LOGOUT,
    ({ user }: ReceiveMessageBodyStatusLogout) => {
      store.commit('onlineStatus/setOnlineStatus', {
        [user]: {
          user,
          isOnline: false
        }
      })
    }
  )
}
